export default __webpack_public_path__ + "static/media/10.776093e7.jpg";